import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import { updateDomain } from '@/services/domain.service'
import executeWithRefresh from '@/composables/useRefresher'
import { useSubmit } from './FormMixin'
import { prop } from 'ramda';


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-domain',
  props: ['buyers', 'domain', 'tds'],
  emits: ['close', 'finish'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const requiredTds = ref('')
const buyersList = ref([])
const tdsList = ref([])

const formData = ref({
  domain: '',
  buyer: null,
  tds: null,
})

const domainId = ref(null)

const request = async (sendData, control) => {
  const error = (await useSubmit(send(sendData), control, true))
}

const send = async data => {
  
  const sendData = {
    domain: formData.value.domain,
    buyer: formData.value.buyer?.id ? formData.value.buyer?.id : null,
    tds: formData.value.tds?.id ? formData.value.tds?.id : null,
  }
  try {
    const res = await (executeWithRefresh(updateDomain, null, {id: domainId.value}, sendData))
    emit('finish', true)
  } catch(e: any) {
    return Promise.reject(e)
  }
}

function onChangeBuyer(el) {
  if(el != undefined) {
    requiredTds.value = 'required'
  }
}

function onClearBuyer(el) {
  formData.value.buyer = null
  requiredTds.value = ''
}


onMounted(() => {
  buyersList.value = props.buyers
  tdsList.value = props.tds
  formData.value.domain = props.domain.domain
  domainId.value = props.domain.id
  formData.value.buyer = props.buyers.find((el) => el.id == props.domain.buyer)
  console.log(props.tds)
  formData.value.tds = props.tds.find((el) => el.id == props.domain.tds)
  console.log(formData.value.tds)
})


const __returned__ = { props, emit, requiredTds, buyersList, tdsList, formData, domainId, request, send, onChangeBuyer, onClearBuyer, ref, onMounted, get updateDomain() { return updateDomain }, get executeWithRefresh() { return executeWithRefresh }, get useSubmit() { return useSubmit }, get prop() { return prop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})